<div class="mat-h3">Trapo zuordnen</div>
<mat-list>
  @for (option of apiData()?.formGroups[0].elements; track option.key; let index = $index) {
    <mat-list-item>
      <mat-checkbox
        [color]="'primary'"
        [(ngModel)]="option.value"
        (change)="assignTrapoChanged(option.key)"
      />
      {{ option.label }}
    </mat-list-item>
  }
</mat-list>

<div class="mat-h3">Revisor</div>
<mat-list>
  @for (option of apiData()?.formGroups[1].elements; track option.key; let index = $index) {
    <mat-list-item>
      <mat-checkbox
        [color]="'primary'"
        [(ngModel)]="option.value"
        (change)="assignRevisorChanged(option.key)"
      />
      {{ option.label }}
    </mat-list-item>
  }
</mat-list>
